var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
      appNoWidth:
        _vm.$route.path == '/data' ||
        _vm.$route.path == '/note' ||
        _vm.$route.path == '/works',
      appNoHeight: _vm.$route.path == '/liveRoom',
    },attrs:{"id":"app"}},[_c('div',{class:{ gHeight: _vm.$route.path == '/Grid' },staticStyle:{"width":"100%","height":"100%"},style:({ overflow: _vm.$route.path == '/liveRoom' ? 'hidden' : '' })},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{class:{ pb_body: _vm.isShowNav }}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{class:{ pb_body: _vm.isShowNav }}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d362168c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 